import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";
import { ZoneEditor } from "./components/member-profile/zone-editor";

/**
 * Mounts the member profile edit form on My Stories, My Projects and My Videos.
 *
 * Everything it needs arrives in data-initial-props: which zone, which item, the item's current
 * values, and every configured limit. Nothing is fetched on mount, so the form paints filled in
 * and a member reopening a draft never sees an empty version of what they wrote.
 *
 * querySelectorAll rather than getElementById because the class is what the view emits and a page
 * carrying two would be a bug worth rendering rather than silently half-ignoring.
 */
function MemberProfileEditorRenderer() {
  const elements = document.querySelectorAll(".react-member-profile-editor");

  elements.forEach((element) => {
    let initialProps = null;

    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(error, "Could not parse initial props JSON for MemberProfileEditor");
      return;
    }

    if (!initialProps) {
      return;
    }

    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <ZoneEditor {...initialProps} />
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initMemberProfileEditor = () => {
  if (document.readyState !== "loading") {
    MemberProfileEditorRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", MemberProfileEditorRenderer);
  }
};
